<script setup lang="ts">
import type { IOpportunity } from '@/pages/forLaywers/model/types/opportunitiesSection';

const isMobile: boolean = useIsMobile();

const opportunities: IOpportunity[] = [
  {
    id: 1,
    mode: '_first',
    text: 'Бесплатное размещение профиля',
  },
  {
    id: 2,
    mode: '_second',
    text: 'Бесплатные заявки от клиентов в личном чате',
  },
  {
    id: 3,
    mode: '_third',
    text: 'Готовые записи клиентов прямо в офис',
  },
  {
    id: 4,
    mode: '_fourth',
    text: 'Удобное расписание для юриста',
  },
];
</script>

<template>
  <section :class="['opportunities', { _mobile: isMobile }]">
    <h2 class="opportunities__title">Возможности</h2>
    <ul class="opportunities__list">
      <li
        v-for="opportunity of opportunities"
        :key="opportunity.id"
        :class="['opportunities__list-item', opportunity.mode]"
      >
        {{ opportunity.text }}
      </li>
    </ul>
  </section>
</template>

<style lang="less">
.opportunities {
  padding-top: 150px;
  padding-bottom: 150px;

  &__list {
    .container-d();

    background: url('/images/lawyers-page/opportunities-bg.svg') center no-repeat;
    background-size: contain;
    height: 690px;
    position: relative;

    @media @desktop {
      height: 670px;
    }

    @media @1366 {
      height: 590px;
    }

    @media @tablet {
      height: 475px;
    }
  }

  &__title {
    .title-section();

    text-align: center;
    margin-bottom: 50px;
  }

  &__list-item {
    font-size: @size-x6;
    line-height: @size-x7;
    font-weight: 400;
    position: absolute;

    @media @1280 {
      font-size: @size-x5;
      line-height: @size-x6;
    }

    @media @tablet {
      font-size: 18px;
      line-height: 22px;
    }

    &._first {
      max-width: 171px;
      top: 41%;
      left: 14.8%;

      @media @1366 {
        top: 39%;
      }

      @media @1280 {
        max-width: 140px;
        top: 41%;
      }

      @media @tablet {
        max-width: 125px;
        top: 39%;
      }
    }

    &._second {
      max-width: 229px;
      top: 9%;
      left: 34%;

      @media @1366 {
        top: 3%;
      }

      @media @1280 {
        max-width: 165px;
        top: 8%;
      }

      @media @tablet {
        top: 3%;
      }
    }

    &._third {
      max-width: 194px;
      top: 41%;
      left: 49.3%;

      @media @1366 {
        top: 39%;
      }

      @media @1280 {
        max-width: 150px;
        top: 41%;
      }

      @media @tablet {
        top: 39%;
      }
    }

    &._fourth {
      max-width: 207px;
      top: 9%;
      left: 69.8%;

      @media @1366 {
        top: 3%;
      }

      @media @1280 {
        top: 8%;
      }

      @media @tablet {
        top: 3%;
      }
    }
  }

  &._mobile {
    padding-top: 43px;
    padding-bottom: 64px;
  }

  &._mobile &__list {
    .container-m();

    background: url('/images/lawyers-page/opportunities-bg-mobile.svg') left no-repeat;
    height: 526px;
  }

  &._mobile &__title {
    font-size: @size-x6;
    line-height: 25px;
    margin-bottom: 10px;
  }

  &._mobile &__list-item {
    font-size: @size-x4;
    line-height: 22px;

    &._first {
      max-width: 110px;
      top: 44px;
      left: 115px;
    }

    &._second {
      max-width: 144px;
      top: 150px;
      left: 203px;
    }

    &._third {
      max-width: 127px;
      top: 272px;
      left: 115px;
    }

    &._fourth {
      max-width: 154px;
      top: 387px;
      left: 203px;
    }
  }
}
</style>
